import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Sun, FlaskConical } from 'lucide-react';
const levers = [{
  icon: Thermometer,
  title: 'Thermal',
  desc: 'Manipulate core body temperature to force your brain into Deep Sleep stages rapidly.'
}, {
  icon: Sun,
  title: 'Photonic',
  desc: "Anchor your circadian rhythm using precise light timing to open your 'Sleep Gate'."
}, {
  icon: FlaskConical,
  title: 'Chemical',
  desc: 'Clear adenosine and manage cortisol without relying on toxic supplements or sleep aids.'
}];
export function Mechanism() {
  return <section className="py-24 relative overflow-hidden" data-id="element-96">
      <div className="absolute inset-0 bg-grid-pattern opacity-30" data-id="element-97" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/5 rounded-full blur-[100px] pointer-events-none" data-id="element-98" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-99">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-100">
          <div className="inline-block px-4 py-1 rounded-full border border-brand-green/30 bg-brand-green/10 text-brand-green font-mono text-sm mb-6" data-id="element-101">
            THE UNIQUE MECHANISM
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-102">
            The Bio-Data Translation Framework
          </h2>
          <p className="text-xl text-brand-gray" data-id="element-103">
            This isn't a book about the biology of sleep. It is a tactical
            manual designed specifically for wearable users. We use your
            device's data as a real-time feedback loop to pull three specific
            biological levers.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-104">
          {levers.map((lever, index) => {
          const Icon = lever.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-[#0a0a0a] border border-[#222] hover:border-brand-green/50 transition-colors duration-300 rounded-3xl p-8 relative group" data-id="element-105">
                <div className="absolute inset-0 bg-gradient-to-b from-brand-green/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl" data-id="element-106" />
                <div className="w-14 h-14 rounded-2xl bg-[#111] border border-[#333] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-107">
                  <Icon className="w-7 h-7 text-brand-green" data-id="element-108" />
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-109">{lever.title}</h3>
                <p className="text-brand-gray leading-relaxed" data-id="element-110">{lever.desc}</p>
              </motion.div>;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-111">
          <p className="text-xl font-medium" data-id="element-112">
            We stop guessing and start executing based on what your nervous
            system is{' '}
            <span className="text-brand-green" data-id="element-113">actually asking for.</span>
          </p>
        </div>
      </div>
    </section>;
}